
export const GLOBAL_COURSE = 'global_course'
export const GLOBAL_CLASS = 'global_class'
export const GLOBAL_DELFILE = 'global_delfile'
export const GLOBAL_TEST_DEGREE = 'global_test_degree'
export const GLOBAL_TEST_TYPE = 'global_test_type'
// export const GLOBAL_DELFILE = 'global_delfile'
// export const GLOBAL_DELFILE = 'global_delfile'
export const GLOBAL_UPLOAD = 'global_upload'
export const GLOBAL_TEST_ADD = 'global_test_add'
export const GLOBAL_TEST_EDIT = 'global_test_edit'
export const GLOBAL_TEST_LIST = 'global_test_list'
export const GLOBAL_DOWN_EXCEL = 'global_down_excel'

export const GLOBAL_TEST_DEL = 'global_test_del'